import React, { FC, useContext, useState } from "react";
import { Dialog } from "@natera/material/lib/dialog";
import { defineMessages, useIntl } from "react-intl";
import { Button } from "@natera/form";
import { UppAuthContext } from "@app/provider";
import "./cancelProfileSetupDialog.scss";

const messages = defineMessages({
  cancelProfileSetupDialogTitle: {
    id: "cancelProfileSetupDialogTitle",
    defaultMessage: "Cancel profile setup?",
  },
  cancelProfileSetupDialogContent: {
    id: "cancelProfileSetupDialogContent",
    defaultMessage:
      "You can use the same login method next time and complete profile setup.",
  },
  cancelProfileSetupDialogYesButton: {
    id: "cancelProfileSetupDialogYesButton",
    defaultMessage: "Yes",
  },
  cancelProfileSetupDialogNoButton: {
    id: "cancelProfileSetupDialogNoButton",
    defaultMessage: "No",
  },
});

interface CancelProfileSetupDialogProps {
  onClose: () => void;
}

const CancelProfileSetupDialog: FC<CancelProfileSetupDialogProps> = ({
  onClose,
}) => {
  const intl = useIntl();
  const { logout } = useContext(UppAuthContext);

  const [isLoading, setIsLoading] = useState(false);

  const header = intl.formatMessage(messages.cancelProfileSetupDialogTitle);
  const content = (
    <p>{intl.formatMessage(messages.cancelProfileSetupDialogContent)}</p>
  );

  const handleYes = async () => {
    try {
      setIsLoading(true);
      await logout();
    } finally {
      setIsLoading(false);
    }
  };

  const onCloseHandler = () => {
    if (isLoading) {
      return;
    }
    onClose();
  };

  const actions = (
    <>
      <Button onClick={handleYes} unelevated loading={isLoading}>
        {intl.formatMessage(messages.cancelProfileSetupDialogYesButton)}
      </Button>
      <Button onClick={onClose} outlined loading={isLoading}>
        {intl.formatMessage(messages.cancelProfileSetupDialogNoButton)}
      </Button>
    </>
  );

  return (
    <Dialog
      className="cancel-profile-setup-dialog"
      onClose={onCloseHandler}
      title={header}
      showCrossButton
      actions={actions}
    >
      <div className="cancel-profile-setup-dialog__content">{content}</div>
    </Dialog>
  );
};

export default CancelProfileSetupDialog;
